import Base from "./base/index";
import { ICourse } from "./base/types";
import { ServiceResponse } from "../../types";
import LmsBuildClient from "../../../../build/buildClient";
import { TENANT_ID, LMS_API_KEY } from "../../../config-global";
import {
  ICourseResource,
  GetBuildCourseInput,
  GetBuildCoursesInput,
} from "./types";
import {
  GET_BUILD_COURSE,
  GET_BUILD_COURSES,
  GET_BUILD_COURSE_RESOURCES,
} from "./graphql";

const getBuildCourses = async (
  lastUpdated: string,
  nextToken?: string
): Promise<ServiceResponse<ICourse[] | undefined>> => {
  let data: any | undefined;
  try {
    const input: GetBuildCoursesInput = {
      tenantId: TENANT_ID,
      so: lastUpdated,
      limit: 1000,
    };

    data = (
      await LmsBuildClient.request({
        method: "post",
        headers: {
          "x-api-key": LMS_API_KEY,
        },
        data: {
          query: GET_BUILD_COURSES,
          variables: {
            input: { ...input, nextToken },
          },
        },
      })
    )?.data;

    return {
      ...data.data.getBuildCourses,
      success: !!data.data.getBuildCourses.data,
    };
  } catch (err) {
    console.error("getBuildCourses", err);
    if (data?.errors) {
      console.error("getBuildCourses", data?.errors);
    }
    return {
      success: false,
    };
  }
};
const getBuildCourse = async (
  id: string
): Promise<ServiceResponse<ICourse | undefined>> => {
  let data: any | undefined;

  const input: GetBuildCourseInput = {
    tenantId: TENANT_ID,
    id,
  };

  try {
    data = (
      await LmsBuildClient.request({
        method: "post",
        headers: {
          "x-api-key": LMS_API_KEY,
        },
        data: {
          query: GET_BUILD_COURSE,
          variables: {
            input,
          },
        },
      })
    )?.data;

    return {
      data: data.data.getBuildCourse,
      success: !!data.data.getBuildCourse,
    };
  } catch (err) {
    console.error("getBuildCourse", err, input);
    if (data?.errors) {
      console.error("getBuildCourse", data?.errors);
    }
    return {
      success: false,
    };
  }
};
const getBuildCourseResources = async (
  lastUpdated: string,
  nextToken?: string
): Promise<ServiceResponse<ICourseResource[]>> => {
  let data: any | undefined;
  try {
    const input: GetBuildCoursesInput = {
      tenantId: TENANT_ID,
      so: lastUpdated,
      limit: 1000,
    };

    data = (
      await LmsBuildClient.request({
        method: "post",
        headers: {
          "x-api-key": LMS_API_KEY,
        },
        data: {
          query: GET_BUILD_COURSE_RESOURCES,
          variables: {
            input: { ...input, nextToken },
          },
        },
      })
    )?.data;

    return {
      ...data.data.getBuildCourseResources,
      success: !!data.data.getBuildCourseResources.data,
    };
  } catch (err) {
    console.error("getBuildCourseResources", err, data);
    if (data?.errors) {
      console.error("getBuildCourseResources", data?.errors);
    }
    return {
      success: false,
    };
  }
};

const CourseService = {
  getBuildCourses,
  getBuildCourse,
  getBuildCourseResources,
};

export default {
  ...Base,
  ...CourseService,
};
